import * as fromDataType from '../datatype-library/index'

export interface bl_applet_one_time_perm_request_history_RowInterface {
    guid: fromDataType.GuidDataFieldInterface;
    generic_doc_line_guid: fromDataType.GuidDataFieldInterface;
    approver_subject_guid: fromDataType.GuidDataFieldInterface;
    approvals_status: fromDataType.VarcharDatatypeInterface;
    namespace: fromDataType.VarcharDatatypeInterface;
    property_json: fromDataType.JsonDatatypeInterface;
    acl_config: fromDataType.JsonDatatypeInterface;
    acl_policy: fromDataType.JsonDatatypeInterface;
    created_date: fromDataType.TimestampTzDatatypeInterface;
    updated_date: fromDataType.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDataType.GuidDataFieldInterface;
    created_by_name: fromDataType.VarcharDatatypeInterface;
    updated_by_subject_guid: fromDataType.GuidDataFieldInterface;
    updated_by_name: fromDataType.VarcharDatatypeInterface;
    status: fromDataType.VarcharDatatypeInterface;
    revision: fromDataType.GuidDataFieldInterface;
    vrsn: fromDataType.VarcharDatatypeInterface;
}

export class bl_applet_one_time_perm_request_history_RowClass implements bl_applet_one_time_perm_request_history_RowInterface {
    guid: fromDataType.GuidDataFieldInterface;
    generic_doc_line_guid: fromDataType.GuidDataFieldInterface;
    approver_subject_guid: fromDataType.GuidDataFieldInterface;
    approvals_status: fromDataType.VarcharDatatypeInterface;
    namespace: fromDataType.VarcharDatatypeInterface;
    property_json: fromDataType.JsonDatatypeInterface;
    acl_config: fromDataType.JsonDatatypeInterface;
    acl_policy: fromDataType.JsonDatatypeInterface;
    created_date: fromDataType.TimestampTzDatatypeInterface;
    updated_date: fromDataType.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDataType.GuidDataFieldInterface;
    created_by_name: fromDataType.VarcharDatatypeInterface;
    updated_by_subject_guid: fromDataType.GuidDataFieldInterface;
    updated_by_name: fromDataType.VarcharDatatypeInterface;
    status: fromDataType.VarcharDatatypeInterface;
    revision: fromDataType.GuidDataFieldInterface;
    vrsn: fromDataType.VarcharDatatypeInterface;
}